import React from 'react';
import './Section3.css';


function Section3() {
  const campClick = () => {
    window.open("https://www.mowsatx.org/?utm_source=landing_page&utm_medium=button&utm_campaign=twa_meals_on_wheels&utm_content=dyi",
     "_blank");
  };
  return (
    <div className="joy-container">
        <div className="joy-image">
        </div>
        <div className="joy-day-text-container">
            <div className="joy-title"></div>
            <div className="joy-p">Meals on Wheels San Antonio was established 
            in 1977, in conjunction with Grace Place Alzheimer’s 
            Activity Centers. Through public-private partnerships, 
            Meals on Wheels San Antonio volunteers and staff visit 
            more than 4,500 clients’ homes in Bexar, and surrounding 
            counties, each weekday to deliver more than a meal. </div>
            <button className="joy-btn" onClick={campClick}>FIND OUT MORE</button>
        </div>
    </div>
  )
}

export default Section3